import React from "react";
import { formatLongDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  activeSubscription: server.dto.Subscription
  nextSubscriptionType: server.dto.SubscriptionType
  nextBillingCycle: server.dto.BillingCycle
}

const NextIsFree = (props: Props) => <div className="message ui blue">
  {RESX.Subscription.SwitchesToFreeOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</div>;

const NextIsAgainFree = () => (
  <div className="ui message blue">{RESX.Subscription.ThisAccountIsForNonCommercialPurposes}</div>);

const NextIsPaid = (props: Props) => <div className="message ui green">
  {RESX.Subscription.SwitchesToPaidOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</div>;

const NextIsReadOnly = (props: Props) => <div className="message ui red">
  {RESX.Subscription.SwitchesToReadOnlyOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}
</div>;

const NextIsAgainReadOnly = (props: Props) => (<>
  <table className="s1_table clean rowspace-small margin-bottom-large">
    <tbody>
      <tr>
        <td>{RESX.Subscription.Renewal}:</td>
        <td>{formatLongDate(props.activeSubscription.end)}</td>
      </tr>
    </tbody>
  </table>

  <div className="ui message blue">
    {RESX.Subscription.YouCanReactivateAnyMoment}
  </div>
</>);

const TermsRow = () => (<tr>
  <td>{RESX.Subscription.Terms}:</td>
  <td><a href={routes.content_LicenceTerms().absolute}>{RESX.Subscription.EndUserLicenceTerms}</a></td>
</tr>
);

interface NextIsCancelledProps extends Props {
  tip?: "readOnly"
}

const NextIsCancelled = (props: NextIsCancelledProps) => <div className="ui message red">

  <div className="margin-bottom-small">
    <strong>{RESX.Subscription.AccountClosesOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}</strong>
  </div>

  {props.tip === "readOnly" && <div>
    {RESX.Subscription.ContactUsToChangeToReadOnly}
  </div>}
</div>;

const NextIsTrialEnd = (props: Props) => {
  return <div className="ui message blue margin-bottom-larger">
    {
      props.activeSubscription.type === "trial" && <div className="margin-bottom-small">
        <strong>{RESX.Subscription.TrailEndsOnX.replace("{0}", formatLongDate(props.activeSubscription.end))}</strong>
      </div>
    }
    <div>
      {RESX.Subscription.ContactUsToActivateOrExtendTrial}
    </div >
  </div >;
};

const NotImplementedSubscription = () => (<div className="ui message red">
  {RESX.Subscription.SomethingWentWrong}
</div>);

export { NextIsAgainFree, NextIsAgainReadOnly, NextIsCancelled, NextIsFree, NextIsPaid, NextIsReadOnly, NextIsTrialEnd, NotImplementedSubscription, TermsRow };

